export default {
  Login: "ACCEDI"
};
